import React, { useState } from "react";
import helperSpinner from "../../../helpers/spinner";
import httpService from "../../../services/httpServices/httpServices";
import { useHistory } from "react-router";

function ConfirmTypeUser({ userID, confirm_type_info, reason_ban_info }) {
  const history = useHistory();

  const sendForm = async (e) => {
    e.preventDefault();
    const data = getDataForm();

    const result = await sendRequestConfirmTypeUser(data);
    if (!result) {
      return;
    }
    history.push("/user/all");
  };

  const getDataForm = () => {
    return {
      user_id: parseInt(userID),
      confirm: parseInt(document.querySelector("#confirm").value),
      message: document.querySelector("#reason-fail-data").value,
    };
  };

  const sendRequestConfirmTypeUser = async (data) => {
    const headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/confirm-type-info",
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  };

  return (
    <div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <form onSubmit={sendForm}>
            <label>بررسی اطلاعات حقوقی و حقیقی برای صدور فاکتور رسمی</label>
            <p class="alert alert-info">
              اطلاعات کاربر نظیر کد ملی , شماره شناسنامه برای کاربر حقیقی و
              شناسه ملی , شماره اقتصادی , شماره ثبت برای کاربر حقوقی برای صدور
              فاکتور رسمی پرداخت , صحت سنجی کنید.
            </p>
            <select class="form-control" id="confirm">
              <option
                value="1"
                selected={confirm_type_info == 1 ? "selected" : ""}
              >
                تایید
              </option>
              <option
                value="0"
                selected={confirm_type_info == 0 ? "selected" : ""}
              >
                رد
              </option>
            </select>
            <br />
            <textarea
              class="form-control"
              id="reason-fail-data"
              placeholder="دلیل رد شدن اطلاعات کاربر را بنویسید"
              defaultValue={reason_ban_info}
            ></textarea>
            <br />
            <button types="submit" class="btn btn-primary">
              اعمال
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ConfirmTypeUser;
